export default "__VITE_ASSET__B76HTvDC__"